import { Brand } from './components/brand/Brand';
import { PaintType } from './components/paint-type/PaintType';
import { Sheen } from './components/sheen/Sheen';

export const PaintModalContent = {
  Brand,
  PaintType,
  Sheen
};
